module.exports = __webpack_public_path__ + "static/media/youtube.5281d3b3.svg";